import * as React from 'react';
import { useField } from 'formik';

import { Select } from 'components/common';
import { ControlLabel } from 'components/bootstrap';
import { Col } from 'security-app/components/common/FormBaseStyles';

import { ErrorMessage } from './ErrorMessage';

type Props<T> = {
  field: any;
  options: { label: string; value: T }[];
  onChange: (newValue: string) => void;
  label?: string;
  matchProp?: 'label' | 'value';
  disabled?: boolean;
  clearable?: boolean;
  menuPlacement?: 'bottom' | 'auto' | 'top';
};

function FormikSelect<T>({
  field,
  options,
  onChange,
  label = undefined,
  matchProp = 'value',
  disabled = false,
  clearable = true,
  menuPlacement = 'bottom'
}: Props<T>) {
  const [{ name, value }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name });

  const handleChange = React.useCallback(
    (newValue: string) => {
      setValue(newValue);
      onChange(newValue);
    },
    [setValue, onChange],
  );

  return (
    <Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch">
      {label && <ControlLabel>{label}</ControlLabel>}
      <Select
        id={name}
        inputProps={{ 'aria-label': name }}
        name={name}
        matchProp={matchProp}
        onChange={handleChange}
        onBlur={() => setTouched(true)}
        value={value}
        disabled={disabled}
        options={options}
        menuPlacement={menuPlacement}
        clearable={clearable}
      />
      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </Col>
  );
}

export default FormikSelect;
